// extracted by mini-css-extract-plugin
export default {"cell":"styles-module__cell__src-labstep-web-grid-SmartTableProtocolValue-coldefs-bulk-select-_KV71i"};